import isObject from 'lodash/isObject';

import Box from '@gogame/ui/Box';
import Typography from '@gogame/ui/Typography';

import { OPERATOR_SUBTRACT } from '../constants';

export const Default = ({ value }) => {
  if (isObject(value)) {
    // Fix for LegacySwitchView. It has extrarender for case default
    value = value.name;
  }
  if (value === OPERATOR_SUBTRACT) {
    value = <span>&mdash;</span>;
  }
  return (
    <Typography>
      <Box component={'span'} lineHeight={'38px'}>
        {value}
      </Box>
    </Typography>
  );
};
